import { useRef, useState } from "react";

export function useBotGuard() {
  const startedAt = useRef(Date.now());
  const [website, setWebsite] = useState("");

  const guard = (timed = true) => ({
    website,
    ...(timed ? { form_time_ms: Math.max(0, Date.now() - startedAt.current) } : {}),
  });

  const trap = (
    <div
      aria-hidden="true"
      className="absolute left-[-10000px] top-auto h-px w-px overflow-hidden"
    >
      <label>
        Leave this field empty
        <input
          type="text"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          value={website}
          onChange={(event) => setWebsite(event.target.value)}
        />
      </label>
    </div>
  );

  return { trap, guard };
}
